/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Warning } from '../models/Warning';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WarningService {
    /**
     * Returns all currently active warnings (ordered by priority desc and start asc)
     * @returns Warning Returned when successful
     * @throws ApiError
     */
    public static getWarnings({
        geoJson,
    }: {
        /**
         * whether or not response should include geoJson information, default false
         */
        geoJson?: boolean,
    }): CancelablePromise<Array<Warning>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/warning',
            query: {
                'geoJson': geoJson,
            },
        });
    }
    /**
     * Returns warnings for a region (ordered by priority desc and start asc)
     * @returns Warning Returned when successful
     * @throws ApiError
     */
    public static getWarningById({
        id,
        geoJson,
    }: {
        id: string,
        /**
         * whether or not response should include geoJson information, default false
         */
        geoJson?: boolean,
    }): CancelablePromise<Array<Warning>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/warning/id/{id}',
            path: {
                'id': id,
            },
            query: {
                'geoJson': geoJson,
            },
            errors: {
                404: `Returned when the region id is not known`,
            },
        });
    }
    /**
     * @deprecated
     * Returns warnings for several regions (ordered by priority desc and start asc)
     * @returns Warning Returned when successful
     * @throws ApiError
     */
    public static getWarningByIds({
        ids,
        geoJson,
    }: {
        ids: string,
        /**
         * whether or not response should include geoJson information, default false
         */
        geoJson?: boolean,
    }): CancelablePromise<Array<Warning>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/warning/ids/{ids}',
            path: {
                'ids': ids,
            },
            query: {
                'geoJson': geoJson,
            },
            errors: {
                404: `Returned when the region id is not known`,
            },
        });
    }
}
